import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";
import type { RdOptionsResponse } from "../../../shared/api-types";
import { authenticatedApi } from "./api";

/** The accessible-RD roster. One owner of the key and fetch so every consumer
 *  shares a cache entry instead of agreeing by coincidence. */
export function useRdOptions(enabled = true) {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: ["rd-options"],
    queryFn: () => authenticatedApi<RdOptionsResponse>(getToken, "/api/rds/options"),
    staleTime: 5 * 60_000,
    enabled,
  });
}
